import { useContext } from 'react';
import { UserContext } from '../context';
/**
 * Custom React Hook that returns the `UserContext` value
 */
var useUser = function () { return useContext(UserContext); };
export default useUser;
//# sourceMappingURL=useUser.js.map